export function disableScroll() {
  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
}

export function enableScroll() {
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
}